import React from "react";
import { CollectiveInvoiceStatusTypeDisplay } from "../../../../../store/CollectiveInvoice/Displays";
import { CollectiveInvoice } from "../../../../../store/CollectiveInvoice/Types";
import { CreditDebitIndicatorTypeDisplay } from "../../../../../store/Statements/Displays";
import { Grid } from "@vwpfs/mary-air-lib/components/air/03-base/Grid";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { FieldTypes, FormField } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field";

interface OwnProps {
    details: CollectiveInvoice;
}

type Props = OwnProps;

/**
 *
 */
export class Detail
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);

    }

    public render() {
        return (
            <>
                <Div className="scl-b-row">
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            label="Booking date"
                            asSummary
                            value={this.props.details.bookingDate}
                            type={FieldTypes.Date}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            label="Invoice date"
                            asSummary
                            value={this.props.details.invoiceDate}
                            type={FieldTypes.Date}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            value={this.props.details.mutationDate}
                            label="Mutation date"
                            asSummary
                            type={FieldTypes.Date}
                        />
                    </Grid>
                </Div>
                <Div className="scl-b-row">
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            type={FieldTypes.Text}
                            value={CreditDebitIndicatorTypeDisplay[this.props.details.creditDebitIndicator]}
                            label="Mutation type"
                            asSummary
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            value={this.props.details.balance}
                            label="Balance"
                            asSummary
                            type={FieldTypes.CurrencyDisplay}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            value={this.props.details.totalAmount.amount}
                            label="Amount"
                            asSummary
                            type={FieldTypes.CurrencyDisplay}
                        />
                    </Grid>
                </Div>
                <Div className="scl-b-row">
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            type={FieldTypes.Text}
                            value={this.props.details.dealerName}
                            label="Partner name"
                            asSummary
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            type={FieldTypes.Text}
                            value={this.props.details.partnerIBAN}
                            label="Partner IBAN"
                            asSummary
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            type={FieldTypes.Text}
                            value={this.props.details.partnerNumber}
                            label="Partner number"
                            asSummary
                        />
                    </Grid>
                </Div>
                <Div className="scl-b-row">
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            label="Period from"
                            asSummary
                            value={this.props.details.periodFrom}
                            type={FieldTypes.Date}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            label="Period to"
                            asSummary
                            value={this.props.details.periodTo}
                            type={FieldTypes.Date}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 4 }}
                    >
                        <FormField
                            type={FieldTypes.Text}
                            label="Status"
                            asSummary
                            value={CollectiveInvoiceStatusTypeDisplay[this.props.details.status]}
                        />
                    </Grid>
                </Div>
            </>
        );
    }
}
